export const version = '1.6.0';
//# sourceMappingURL=version.js.map